import { render } from "./CompoundTable.vue?vue&type=template&id=6cbf94b9"
import script from "./CompoundTable.vue?vue&type=script&lang=js"
export * from "./CompoundTable.vue?vue&type=script&lang=js"

import "./CompoundTable.vue?vue&type=style&index=0&id=6cbf94b9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__